<template>
    <div class="container">
        <div v-if="!isFormVisible" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> Items</h5>
                <argon-button
size="sm" color="primary" variant="gradient"
                    @click="openCreateModal({ type: 'servicio', tax: 16, discount: 0.00 })">
                    <span class="fa-solid fa-plus" />
                    Crear
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <CustomFilters
:order-options="orderOptions" :items-per-page="itemsPerPage" :view-as-card="viewAsCard"
                    :show-deleted="showDeleted" @apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
                    @update-view-as-card="updateViewAsCard" @update-show-deleted="updateShowDeleted" />
                <div v-if="loading" class="loading-indicator">
                    <p>Cargando datos...</p>
                </div>
                <div v-else>
                    <div v-if="filteredItems.length === 0" class="no-records p-5 px-4">
                        <p>No se encontraron registros. Intenta ajustar los filtros o añadir nuevos registros.</p>
                    </div>
                    <div v-else>
                        <div v-if="!viewAsCard" class="table-responsive">
                            <GenericTable
:data="filteredItems" :headers="headers" @delete-record="deleteItem"
                                @edit-record="openEditModal" @restore-record="restoreItem" />
                        </div>
                        <transition-group ref="listContainer" name="fade-move" tag="div" class="row me-2 ms-2 pt-2">
                            <template v-if="viewAsCard">
                                <div class="card-container">
                                    <GenericCard
v-for="(item) in filteredItems" :key="item.id" :data="item"
                                        class="fade-card" @delete-record="deleteItem" @edit-record="openEditModal"
                                        @restore-record="restoreItem" />
                                </div>
                            </template>
                        </transition-group>
                        <Pagination
:total-items="totalFilteredItems" :current-page="currentPage" :last-page="lastPage"
                            :items-per-page="itemsPerPage" @page-change="changePage" />
                    </div>
                </div>
            </div>
        </div>
        <ModelModal
v-if="showModal && !displayAsForm" v-model="showModal" :is-edit-mode="isEditMode"
            :resource-api="resourceApi" :entity-data="entityData" :display-as-form="displayAsForm"
            :resource-name="resourceName" @entity-updated="handleEntityUpdated">
            <template #default="{ entity, errors }">
                <div class="mb-3">
                    <label for="name" class="form-label">Nombre</label>
                    <input
id="name" v-model="entity.name" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.name }">
                    <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name[0] }}
                    </div>
                </div>
            </template>
        </ModelModal>
        <div v-if="isFormVisible && displayAsForm" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> {{ isEditMode ? 'Editar' : 'Crear' }} Item</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="closeForm">
                    <span class="fa-solid fa-arrow-left" />
                    Volver
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <ModelModal
v-model="showModal" :is-edit-mode="isEditMode" :resource-api="resourceApi"
                    :entity-data="entityData" :display-as-form="displayAsForm" :keep-form-open="keepFormOpen"
                    :resource-name="resourceName" @entity-updated="handleEntityUpdated">
                    <template #default="{ entity, errors }">
                        <div class="form-grid">
                            <!-- Campos generales -->
                            <div class="form-fields">
                                <div class="grid-container">
                                    <div class="form-group">
                                        <label for="name" class="form-label">Nombre</label>
                                        <input
id="name" v-model="entity.name" type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.name }">
                                        <div v-if="errors.name" class="invalid-feedback">
                                            {{ errors.name[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="description" class="form-label">Descripción</label>
                                        <input
id="description" v-model="entity.description" type="text"
                                            class="form-control" :class="{ 'is-invalid': errors.description }">
                                        <div v-if="errors.description" class="invalid-feedback">
                                            {{ errors.description[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="type" class="form-label">Tipo</label>
                                        <ChoicesSelect id="choices-type" v-model="entity.type" :options="typeOptions" />
                                        <div v-if="errors.type" class="invalid-feedback">
                                            {{ errors.type[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="price" class="form-label">Precio</label>
                                        <input
id="price" v-model="entity.price" type="number" class="form-control"
                                            :class="{ 'is-invalid': errors.price }">
                                        <div v-if="errors.price" class="invalid-feedback">
                                            {{ errors.price[0] }}
                                        </div>
                                    </div>

                                    <!-- Sección de Producto -->
                                    <template v-if="entity.type === 'producto'">
                                        <div class="form-group">
                                            <label for="stock" class="form-label">Stock</label>
                                            <input
id="stock" v-model="entity.stock" type="number" class="form-control"
                                                :class="{ 'is-invalid': errors.stock }">
                                            <div v-if="errors.stock" class="invalid-feedback">
                                                {{ errors.stock[0] }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="lot_number" class="form-label">Número de Lote</label>
                                            <input
id="lot_number" v-model="entity.lot_number" type="text"
                                                class="form-control" :class="{ 'is-invalid': errors.lot_number }">
                                            <div v-if="errors.lot_number" class="invalid-feedback">
                                                {{ errors.lot_number[0] }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="expiry_date" class="form-label">Fecha de Expiración</label>
                                            <DatePicker
v-model="entity.expiry_date" :errors="errors"
                                                error-field-name="expiry_date" />
                                        </div>
                                        <div class="form-group">
                                            <label for="tracability_code" class="form-label">Código de
                                                Trazabilidad</label>
                                            <input
id="tracability_code" v-model="entity.tracability_code" type="text"
                                                class="form-control" :class="{ 'is-invalid': errors.tracability_code }">
                                            <div v-if="errors.tracability_code" class="invalid-feedback">
                                                {{ errors.tracability_code[0] }}
                                            </div>
                                        </div>
                                    </template>

                                    <div class="form-group">
                                        <label for="barcode" class="form-label">Código de Barras</label>
                                        <input
id="barcode" v-model="entity.barcode" type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.barcode }">
                                        <div v-if="errors.barcode" class="invalid-feedback">
                                            {{ errors.barcode[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="tax" class="form-label">Impuesto %</label>
                                        <input
id="tax" v-model="entity.tax" type="number" class="form-control"
                                            :class="{ 'is-invalid': errors.tax }">
                                        <div v-if="errors.tax" class="invalid-feedback">
                                            {{ errors.tax[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="discount" class="form-label">Descuento</label>
                                        <input
id="discount" v-model="entity.discount" type="number"
                                            class="form-control" :class="{ 'is-invalid': errors.discount }">
                                        <div v-if="errors.discount" class="invalid-feedback">
                                            {{ errors.discount[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div :class="{ 'is-invalid': errors.category_id }">
                                            <MenuSelectedFull
v-model="entity.category_id" label="Categoría"
                                                apiurl="item-categories" :can-edit-and-add="false" />
                                        </div>
                                        <div v-if="errors.category_id" class="invalid-feedback">
                                            {{ errors.category_id[0] }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="status" class="form-label">Activo</label>
                                        <ToggleSwitch
:key="entity.id" v-model="entity.status" :errors="errors"
                                            error-field-name="status" />
                                        <div v-if="errors.status" class="invalid-feedback">
                                            {{ errors.status[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Imagen -->
                            <div class="form-image">
                                <label for="status" class="form-label">Imagen del Item</label>
                                <img
v-if="entity.id" :src="entity.photo_url || photo_default" alt="Imagen de prueba"
                                    width="200" @click="() => $refs.fileInput.click()">
                                <img v-else :src="photo_default" alt="Imagen de prueba" width="200">
                                <input ref="fileInput" type="file" style="display: none;" @change="onFileChange" />
                            </div>
                        </div>
                    </template>
                </ModelModal>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import * as Choices from "choices.js";
import { useModelActions } from '@/composables/useModelActions';
import ModelModal from '@/components/ModelModal.vue';
import CustomFilters from '@/components/CustomFilters.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import Pagination from '@/components/Pagination.vue';
import GenericCard from './GenericCard.vue';
import GenericTable from '@/components/GenericTable.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import ChoicesSelect from "@/components/ChoicesSelect.vue";
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";
import DatePicker from "@/components/DatePicker.vue";
import photo_default from "@/assets/img/product_icon.png";

import api from "@/services/api";

const resourceApi = 'items';
const resourceName = 'Items';

const orderOptions = [
    { text: 'Fecha de modificación', value: 'updated_at' },
    { text: 'Fecha de creación', value: 'created_at' },
    { text: 'Nombre', value: 'name' }
];

const headers = ref([
    { text: 'Nombre', value: 'name' },
    { text: 'Suscripción', value: 'subscription' },
    { text: 'Activo', value: 'active' },
    { text: 'Creación', value: 'created_at' }
]);

const typeOptions = ref([
    { text: "Seleccionar opción", value: "" },
    { text: "Servicio", value: "servicio" },
    { text: "Producto", value: "producto" }
]);

const showModal = ref(false);
const isEditMode = ref(false);

const entityData = ref({
    name: '',
    description: '',
    type: 'producto',
    price: 0,
    stock: 0,
    lot_number: '',
    expiry_date: '',
    tracability_code: '',
    barcode: '',
    tax: 0,
    discount: 0.0,
    photo: null,
    photo_url: '',
    category_id: null,
    status: true
});
const { proxy } = getCurrentInstance();

const updatePhoto = async (file) => {
    const formData = new FormData();
    formData.append('photo', file);

    try {
        const response = await api.post(`/items/${entityData.value.id}/update-photo`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        entityData.value = { ...entityData.value, photo_url: response.data.data.photo_url };
        proxy.$notify(response.data.message, "", "success", "ni ni-like-2 ni-lg");
    } catch (error) {
        console.error('Error al actualizar la foto:', error);
        proxy.$notify("Error al actualizar la foto. Por favor, inténtelo de nuevo.", "", "danger", "ni ni-fat-remove ni-lg");
    }
};

const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        updatePhoto(file);
    }
};

const viewAsCard = ref(true);
const showDeleted = ref(false);
const loading = ref(true);
const displayAsForm = ref(true);
const keepFormOpen = ref(true);
const isFormVisible = ref(false);

const {
    openCreateModal,
    openEditModal,
    handleEntityUpdated,
    applyFilter,
    updateItemsPerPage,
    updateViewAsCard,
    updateShowDeleted,
    restoreItem,
    deleteItem,
    fetchItems,
    changePage,
    filteredItems,
    totalFilteredItems,
    currentPage,
    itemsPerPage,
    lastPage
} = useModelActions(resourceApi, {
    showModal,
    isEditMode,
    entityData,
    viewAsCard,
    showDeleted,
    displayAsForm,
    loading,
    isFormVisible,
    keepFormOpen,
    resourceName
});

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

watch(showModal, async (newValue) => {
    if (newValue) {
        await nextTick();
        initializeChoices("choices-type");
    }
});

const initializeChoices = async (elementId) => {
    await nextTick();
    const element = document.getElementById(elementId);
    if (element && !element.classList.contains('choices__input')) {
        new Choices(element, { allowHTML: true });
    }
};

onMounted(async () => {
    await fetchItems();
    initializeChoices("choices-type");
});

const closeForm = () => {
    isFormVisible.value = false;
    fetchItems(currentPage.value);
};

</script>

<style scoped>
.form-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 15px;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-image {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.card-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
}

.fade-card {
    width: 100%;
}
</style>
